// Converted from application/views/scenarios_v.php. Edit this component directly.
export default function ScenariosPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/scenarios/harry-clarke-windows.jpg"} alt={"“Harry Clarke Windows, 1927” – Bewley’s Café, Dublin"} />
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1 style={{"marginBottom":"3rem"}}>{"Scenarios"}</h1>
<h2>{"2020"}</h2>
<h2>{"“Harry Clarke Windows, 1927” – Bewley’s Café, Dublin"}</h2>
</div>
</div>
</div>
</div>
<p style={{"padding":"2rem 4rem 0 4rem"}}>{"\n    These Scenarios are the result of twenty years in Florence sculpting in wax to produce moulds for bronze figures and portraits."}<br />{"\n    Ever reluctant to throw out anything I began to restore those little wax figures which had been broken and damaged by the mould making process."}<br />{"\n    The years spent painting people and places began playback in my mind, and I wanted to put the figures into context, as if they were figures in a painting of a café, or a train carriage, or a bathroom…\n"}</p>
<p style={{"fontWeight":"bold","padding":"0 4rem 4rem 4rem"}}>{"Paddy Campbell"}</p>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/scenarios/viaggio-il-treno.jpg"} alt={"“Il Vaggio sul Treno” – Bewley’s Café, Dublin"} />
</figure>
<div class={"text"}>
<div>
<h3>{"2015"}</h3>
<h2>{"\n                “Il Vaggio sul Treno” – Bewley’s Café, Dublin\n            "}</h2>
</div>
</div>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/scenarios/mercato.jpg"} alt={"“Il Mercato Sant ‘Ambrogio, Firenze“ - Palazzo Medici Riccardi, Florence"} />
<img src={"/assets/images/scenarios/mercato2.jpg"} alt={"“Il Mercato Sant ‘Ambrogio second image, Firenze“ - Palazzo Medici Riccardi, Florence"} />
</figure>
<div class={"text"}>
<div>
<h3>{"2013"}</h3>
<h2>{"\n                “Il Mercato Sant ‘Ambrogio, Firenze - Palazzo Medici Riccardi, Florence\n            "}</h2>
</div>
</div>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/scenarios/carol-singers.jpg"} alt={"“Christmas Carols” – Bewley’s Café, Dublin"} />
</figure>
<div class={"text"}>
<div>
<h3>{"2012"}</h3>
<h2>{"\n                “Christmas Carols” – Bewley’s Café, Dublin\n            "}</h2>
</div>
</div>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/scenarios/la-colazione.jpg"} alt={"“La Colazione” – Un Altro Mondo Exhibition, Fiesole, Italy"} />
</figure>
<div class={"text"}>
<div>
<h3>{"2010"}</h3>
<h2>{"\n                “La Colazione” – Un Altro Mondo Exhibition, Fiesole, Italy\n            "}</h2>
</div>
</div>
</div>
</>;
}
